export default "__VITE_ASSET__CQBCjZ8u__"